            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate>
        <b-row>
          <b-form-group
            label="Nombre"
          >
            <b-form-input v-model="list_forma.name" trim></b-form-input>
          </b-form-group>    
        </b-row>
      </b-form>
     <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px">
        <b-row style="padding-top: 10px;">
          <b-col class="text-right">             
              <b-button  @click="saveForm()" 
                variant="success" 
                size="sm" 
                class="ml-2" 
                v-ripple="'rgba(255, 255, 255, 0.10)'" 
              >Guardar forma de pago
              </b-button>
          </b-col>
        </b-row> 
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import saveMixins  from '@/mixings/save.js'
export default 
{
  name: 'swmodalasesor',
  mixins: [saveMixins],
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform        
  },
  props: {
  },
  data()
  {
    return {
      list_forma: { id: null,name: ''}
    }
  },
  async created()
  {
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})    
  },
  computed: { 
  },
  methods: {
    async saveForm()
    {
      await this.updateDataPost({
        data: {
          data: [{list_forma: this.list_forma}],
          tablaDelete: [],
          tablaAuditar: true,
          tablaPost: [],
          route: 'save_all'
        }
      })
      await this.save(false,true)
      const await1 =  this.updateDataPost({state: 'data',data: []})
      const await2 = this.resetGlobal({state: 'saveConfig/capa'})
      await await1
      await await2
      await this.$emit('cerrar')

    }
  }
}
</script>
<style>
</style>